import {API} from './API.js';
import {Board} from './Board.js';
import {BoardList} from './BoardList.js';
import {Quilter} from './Quilter.js';
import {Template} from './Template.js';

export class Boards {
	static API() {
		console.log(`Boards.API script=`, Boards.script);
		return new API(Boards.script);
	}
	static init() {
		console.log(`Boards.init script=`, Boards.script);
	}
}
Boards.script = document.currentScript.src;
console.log(`loaded boards.js, script = ${Boards.script}, boards.API = `, Boards.API);

document.addEventListener(`DOMContentLoaded`, function() {
	Boards.init();
});